import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ProfessionalInputForm from './pages/professional-input-form';
import ProsperousIncomeBlueprint from './pages/prosperous-income-blueprint';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<ProfessionalInputForm />} />
        <Route path="/professional-input-form" element={<ProfessionalInputForm />} />
        <Route path="/prosperous-income-blueprint" element={<ProsperousIncomeBlueprint />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
